import { Box, Typography } from "@mui/material";

export const getAppColumns = (colors) => {
  return {
    isUsingAI: {
      field: "is_using_ai",
      headerName: "Using AI",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      valueGetter: (params) => {
        return params.row.is_using_ai === true ? "Yes" : null;
      },
      renderCell: (params) => {
        const value = params.value;
        if (value === "Yes") {
          return (
            <Box display="flex" alignItems="center">
              <Typography variant="caption" sx={{ color: colors.grey_700 }}>
                {params.value}
              </Typography>
            </Box>
          );
        }
        return (
          <Box display="flex" alignItems="center">
            <Typography variant="caption" sx={{ color: colors.text_disabled }}>
              N/A
            </Typography>
          </Box>
        );
      },
    },
    yourDataIsUsedForTraining: {
      field: "your_data_is_used_for_training",
      headerName: "Data Used for Training",
      minWidth: 200,
      flex: 1,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      valueGetter: (params) => {
        const trainingValue = params.row.your_data_is_used_for_training;

        if (trainingValue && trainingValue.trim() !== "") {
          return trainingValue;
        }

        return null;
      },
      renderCell: (params) => {
        const value = params.value;
        if (value) {
          return (
            <Box display="flex" alignItems="center">
              <Typography variant="caption" sx={{ color: colors.grey_700 }}>
                {params.value}
              </Typography>
            </Box>
          );
        }

        return (
          <Typography variant="caption" sx={{ color: colors.text_disabled }}>
            N/A
          </Typography>
        );
      },
    },
  };
};
